
    var riot = require('riot')
    //src: starling/src/tags/user-guide-item.html
riot.tag2('user-guide-item',
  '<div> <div class="user-guide-item-titlebar" onclick="{toggleHidden}"> <i class="material-icons">{expandCollapseArrow}</i> {title} </div> <div hide="{this.hidden}" class="user-guide-item-detail"> <div onclick="{handleTextClick}" class="summary"> <raw html="{text}"></raw> </div> <a if="{category !== \'video\' && (imageType === \'video\' || imageType === \'image\')}" onclick="{handleImageClick}"> <video ref="video" if="{imageType === \'video\'}" loop="loop" height="{imageHeight}" riot-src="{imageSource}"></video> <img if="{imageType === \'image\'}" ref="image" height="{imageHeight}" riot-src="{imageSource}"> </a> <img if="{category === \'video\'}" ref="image" onclick="{handleImageClick}" class="video-preview" riot-src="{imageSource}"> <i if="{category === \'video\'}" class="material-icons play-button" onclick="{handleImageClick}">play_circle_outline</i> </div> </div>',
  '',
  'class="user-guide-item {this.hidden ? \'\' : \'expanded\'} user-guide-item--{this.key}" ref="main"', function(opts) {
'use strict';

var _this = this;

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.userGuide = this.opts.userguide;
this.hidden = true;
this.expandCollapseArrow = 'keyboard_arrow_right';
this.imageSource = '';

var canvas = this.opts.canvas;

this.pauseVideo = function () {
  if (_this.imageSource && _this.imageType === 'video') {
    if (_this.refs.video) {
      _this.refs.video.pause();
      _this.refs.video.currentTime = 0;
    }
  }
};

this.playVideo = function () {
  if (_this.imageSource && _this.imageType === 'video') {
    if (_this.refs.video) {
      _this.refs.video.currentTime = 0;
      _this.refs.video.play();
    }
  }
};

this.hide = function () {
  _this.hidden = true;
  _this.expandCollapseArrow = 'keyboard_arrow_right';
  _this.update();
  _this.pauseVideo();
};

this.show = function (e) {
  if (_this.userGuide.openUserGuideItem) {
    _this.userGuide.openUserGuideItem.hide();
  }
  _this.imageSource = _this.imageUrl;
  _this.userGuide.openUserGuideItem = _this;
  _this.expandCollapseArrow = 'keyboard_arrow_down';
  _this.hidden = false;
  _this.update();
  _this.refs.main.scrollIntoView({ block: 'nearest' });
  _this.playVideo();
};

this.handleImageClick = function (e) {
  if (_this.category == 'video') {
    _this.userGuide.canvas.introModalTag.show();
  } else {
    canvas.lightbox.show(_this.imageSource, { imageType: _this.imageType, showControls: false, loop: true, autoPlay: true });
  }
};

// don't interfere with selection of text inside a textarea
this.handleTextClick = function (e) {
  if (e.target && e.target instanceof HTMLTextAreaElement) {
    e.preventDefault();
    e.stopPropagation();
  }
};

this.toggleHidden = function (e) {
  if (_this.hidden) {
    _this.show(e);
    _eventTracking2.default.track({
      category: 'User-Guide',
      action: 'Open-User-Guide-Item',
      label: 'User-Guide-' + _this.key
    });
  } else {
    _this.hide();
  }
};
this.on('mount', function () {
  /* if (this.userGuide.defaultUserGuideItem && this.userGuide.defaultUserGuideItem === this.key) { this.show(); */
  /* } */
  _this.userGuide.userGuideItemTags[_this.title] = _this;
  _this.userGuide.userGuideItemOrder.push(_this.title);
});

this.nextItem = function () {
  var order = _this.userGuide.userGuideItemOrder;
  var myIdx = order.indexOf(_this.title);
  var nextKey = order[myIdx + 1];
  if (!nextKey) return false;
  return _this.userGuide.userGuideItemTags[nextKey];
};

this.prevItem = function () {
  var order = _this.userGuide.userGuideItemOrder;
  var myIdx = order.indexOf(_this.title);
  var prevKey = order[myIdx - 1];
  if (!prevKey) return false;
  return _this.userGuide.userGuideItemTags[prevKey];
};

this.goToNext = function () {
  _this.nextItem().show();
};

this.goToPrev = function () {
  _this.prevItem().show();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('user-guide-item')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/user-guide-item.html
// module id = 598
// module chunks = 0